import { AuthenticatedAPIBO } from '../../core-apis/src/apis/config/api/authenticatedApiBO'

const WIGGOT_API_LEGACY = process.env.WIGGOT_API_LEGACY ?? ''

class BackOfficeApiAuth extends AuthenticatedAPIBO {
  constructor() {
    super({
      domain: WIGGOT_API_LEGACY
    })
  }
}

export const backOfficeApiAuth = new BackOfficeApiAuth()
